import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { useFormik } from 'formik'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import CircularProgress from '@mui/material/CircularProgress'
import { useAuthentication } from '../contexts/AuthenticationContext'
import { useTeams } from '../contexts/TeamsContext'
import TeamIndexPage from './teams/TeamIndexPage'

function Home() {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuthentication()
  const { teams, loading } = useTeams()
  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
    },
    onSubmit: (values) => {
      console.log('Form submitted:', values)
    },
  })

  useEffect(() => {
    if (isAuthenticated && !loading && teams.length === 1) {
      navigate(`/teams/${teams[0].slug}`, { replace: true })
    }
  }, [isAuthenticated, loading, teams, navigate])

  if (isAuthenticated) {
    if (loading) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <CircularProgress />
        </Box>
      )
    }

    if (teams.length === 1) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <CircularProgress />
        </Box>
      )
    }

    return (
      <Container maxWidth="md">
        <Box sx={{ my: 4 }}>
          <TeamIndexPage />
        </Box>
      </Container>
    )
  }

  return (
    <Container maxWidth="sm">
      <Box sx={{ my: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          <FormattedMessage id="app.welcome" />
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          <FormattedMessage id="app.description" />
        </Typography>

        <Paper sx={{ p: 3, mt: 4 }}>
          <Typography variant="h6" gutterBottom>
            Contact Form
          </Typography>
          <Box component="form" onSubmit={formik.handleSubmit}>
            <TextField
              fullWidth
              id="name"
              name="name"
              label={<FormattedMessage id="form.name" />}
              value={formik.values.name}
              onChange={formik.handleChange}
              margin="normal"
            />
            <TextField
              fullWidth
              id="email"
              name="email"
              label={<FormattedMessage id="form.email" />}
              value={formik.values.email}
              onChange={formik.handleChange}
              margin="normal"
            />
            <Button
              color="primary"
              variant="contained"
              type="submit"
              sx={{ mt: 2 }}
            >
              <FormattedMessage id="form.submit" />
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  )
}

export default Home
